exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.van-icon-wechat[data-v-59b3d85a]{color:green;}\n.wrapper .actions[data-v-59b3d85a] {\n    padding: 0.8rem 0.4rem 0.4rem;\n}\n", ""]);

// exports
